/* JavaMania theme.js — storefront interactions */
(function(){
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var money  = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  function $(s, ctx){ return (ctx||document).querySelector(s); }
  function $$(s, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(s)); }

  function formatMoney(cents){
    var v = (cents/100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  }

  /* ---------- search overlay ---------- */
  var search = $('#search-overlay');
  var sToggle = $('#search-toggle');
  var sClose = $('#search-close');
  if (sToggle && search){
    sToggle.addEventListener('click', function(){
      search.hidden = false;
      var inp = $('input', search);
      if (inp) setTimeout(function(){ inp.focus(); }, 40);
    });
  }
  if (sClose && search) sClose.addEventListener('click', function(){ search.hidden = true; });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      if (search) search.hidden = true;
      closeMobile();
    }
  });

  /* ---------- mobile menu ---------- */
  var mobile = $('#mobile-menu');
  var mToggle = $('#menu-toggle');
  var mClose = $('#mobile-close');
  function openMobile(){ if (mobile){ mobile.hidden = false; document.body.style.overflow='hidden'; } }
  function closeMobile(){ if (mobile){ mobile.hidden = true; document.body.style.overflow=''; } }
  if (mToggle) mToggle.addEventListener('click', openMobile);
  if (mClose)  mClose.addEventListener('click', closeMobile);

  /* ---------- popup ---------- */
  var popup = $('#popup');
  if (popup){
    var delay = parseInt(popup.getAttribute('data-delay'),10) || 12000;
    if (!localStorage.getItem('jm-popup')){
      setTimeout(function(){ popup.hidden = false; }, delay);
    }
    var pClose = $('#popup-close');
    if (pClose) pClose.addEventListener('click', function(){
      popup.hidden = true;
      try{ localStorage.setItem('jm-popup','1'); }catch(e){}
    });
    // also close on form submit
    var pForm = popup.querySelector('form');
    if (pForm) pForm.addEventListener('submit', function(){
      try{ localStorage.setItem('jm-popup','1'); }catch(e){}
    });
  }

  /* ---------- cookie banner ---------- */
  var cookie = $('#cookie-bar');
  if (cookie){
    if (!localStorage.getItem('jm-cookie')){
      setTimeout(function(){ cookie.hidden = false; }, 1200);
    }
    var cBtn = $('#cookie-agree');
    if (cBtn) cBtn.addEventListener('click', function(){
      cookie.hidden = true;
      try{ localStorage.setItem('jm-cookie','1'); }catch(e){}
    });
  }

  /* ---------- product page: variant picker + gallery ---------- */
  var pForm = $('#product-form');
  if (pForm){
    var selects = $$('select[data-index]', pForm);
    var variantSelect = $('#product-select');
    var atc = $('#add-to-cart');
    var priceWrap = $('.product__price');

    function getVariantsFromSelect(){
      var opts = $$('option', variantSelect);
      return opts.map(function(o){
        return { id: o.value, title: o.textContent.trim(), disabled: o.disabled };
      });
    }

    function syncVariant(){
      var chosen = selects.map(function(s){ return s.value; }).join(' / ');
      var matched = null;
      $$('option', variantSelect).forEach(function(o){
        if (o.textContent.trim() === chosen) matched = o;
      });
      if (!matched) return;
      variantSelect.value = matched.value;
      if (priceWrap){
        var priceText = matched.getAttribute('data-price');
        if (priceText) {
          var moneySpan = priceWrap.querySelector('span:not(.product-card__was)');
          if (moneySpan) moneySpan.textContent = priceText;
        }
      }
      if (atc){
        if (matched.disabled){
          atc.disabled = true;
          atc.textContent = 'Sold out';
        } else {
          atc.disabled = false;
          atc.textContent = 'Add to cart';
        }
      }
    }
    selects.forEach(function(s){ s.addEventListener('change', syncVariant); });

    // thumbs
    var main = $('#product-main-image');
    $$('.product__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        $$('.product__thumb').forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main) main.src = t.getAttribute('data-src');
      });
    });

    // AJAX add-to-cart with redirect fallback
    pForm.addEventListener('submit', function(e){
      if (!routes.cartAdd) return; // fallback to normal POST
      e.preventDefault();
      var fd = new FormData(pForm);
      fetch(routes.cartAdd + '.js', { method:'POST', body: fd, headers:{'Accept':'application/json'} })
        .then(function(r){ return r.json(); })
        .then(function(){
          window.location.href = routes.cart || '/cart';
        })
        .catch(function(){ pForm.submit(); });
    });
  }

  /* ---------- cart page: quantity steppers ---------- */
  $$('.cart-qty').forEach(function(wrap){
    var input = wrap.querySelector('input');
    var dec = wrap.querySelector('[data-act="dec"]');
    var inc = wrap.querySelector('[data-act="inc"]');
    if (dec) dec.addEventListener('click', function(){
      input.value = Math.max(0, parseInt(input.value || '0',10) - 1);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    if (inc) inc.addEventListener('click', function(){
      input.value = parseInt(input.value || '0',10) + 1;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  /* ---------- header cart badge refresh ---------- */
  if (routes.cart){
    fetch(routes.cart + '.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if (!c) return;
        var b = $('#cart-badge');
        if (b){
          b.textContent = c.item_count;
          b.style.display = c.item_count ? 'inline-flex' : 'none';
        }
      })
      .catch(function(){});
  }
})();
